import { render } from "./user-index.vue?vue&type=template&id=2d80986e&scoped=true&ts=true"
import script from "./user-index.vue?vue&type=script&lang=ts"
export * from "./user-index.vue?vue&type=script&lang=ts"

import "./user-index.vue?vue&type=style&index=0&id=2d80986e&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d80986e"]])

export default __exports__